// @flow
import React, { Component, type Node } from 'react';
import { Link } from 'react-router-dom';

import { mergeClassNames } from 'utils/functions';

type BadgeProps = {
    /** determines the color of the badge */
    flavor: string,
    /** will be appended to the classes */
    className: string,
    /** if passed `onClick` it will be rendered as an anchor **/
    onClick: () => void,
    /** if passed `href` it will be rendered as an anchor **/
    href: string,
    /** if passed `to` it will be rendered as a Link **/
    to: string,
    /** what will be rendered inside the badge */
    children: Node
}

/** A component for a badge. */
export class Badge extends Component<BadgeProps> {

    static defaultProps = {
        flavor: 'secondary',
    };

    render() {
        let {
            flavor,
            className,
            children,
            ...domProps
        } = this.props;

        className = mergeClassNames('badge', `badge-${flavor}`, this.props.className);

        let Component = 'span';
        if (domProps.to) {
            Component = Link;
        } else if (domProps.href || domProps.onClick) {
            Component = 'a';
        }

        return React.createElement(
            Component,
            { className, ...domProps},
            children,
        );
    }
}

export default Badge;
